import { Injectable } from '@angular/core';
import { LoggerService } from '../services/logger.service';

export interface ToastInfo {
  header: string;
  body: string;
  delay?: number;
  toastClass?: string;
  iconColor?: string;
  link?: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: ToastInfo[] = [];

  constructor(private readonly loggerService: LoggerService) {}

  show(
    header: string,
    body: string,
    delay?: number,
    toastClass?: string,
    iconColor?: string,
    link?: string
  ) {
    this.toasts.push({ header, body, delay, toastClass, iconColor, link });
  }

  remove(toast: any) {
    this.loggerService.log('RT -' + JSON.stringify(toast));
    this.toasts = this.toasts.filter((t) => t !== toast);
  }
  
  public clearToasts() {
    this.loggerService.log('RAT');
    this.toasts = [];
  }
}